<template>
    <div class="value-props td-container">
        <div v-for="(prop, index) in propList" :key="index" class="prop-col">
            <div class="icon-container">
                <img :src="prop.icon" :alt="prop.alt" width="150" height="150"/>
            </div>
            <h2 class="name" v-html="prop.name"></h2>
            <p class="mb-0">
                {{prop.description}}
            </p>
        </div>
    </div>
</template>

<script>import script from './ValueProps';
    export default script;</script>

<style lang="less" scoped=scoped>
    @import "./ValueProps.less";
</style>
